import React from "react";
import {useSelector} from "react-redux";
import DocumentDetailPage from "./document-detail";
import ConnectionDocumentDetailPage from "./connection-document-detail";
import {COMPANY_IMPORTER} from "../../constants/config";

const DocumentDetailWrapper = () => {
    const {companyType} = useSelector((state) => state.user ?? {});

    if (companyType === COMPANY_IMPORTER) {
        return <ConnectionDocumentDetailPage />;
    }

    return <DocumentDetailPage />;
};

export default DocumentDetailWrapper;

